/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { UnorderedListOutlined, CalendarOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { font, weightRegular, weightSemiBold } from 'src/components/css'
import type { ViewModeToggleProps } from './types'

const containerStyles = css`
  display: inline-flex;
  border: 1px solid ${colors.SOFT_STEEL};
  border-radius: 8px;
  overflow: hidden;
  height: 40px;
`

const btnStyles = (active: boolean) => css`
  ${font.body}
  ${active ? weightSemiBold : weightRegular}
  font-size: 13px;
  line-height: 1;
  padding: 0 14px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s ease;
  color: ${active ? colors.NEUTRAL_0 : colors.NEUTRAL_50};
  background: ${active ? colors.SECONDARY_200 : 'transparent'};

  &:hover {
    background: ${active ? colors.SECONDARY_200 : colors.SECONDARY_300};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const ViewModeToggle = ({
  viewMode,
  onViewModeChange,
  disabled = false,
}: ViewModeToggleProps) => {
  'use memo'

  return (
    <div css={containerStyles}>
      <button
        type='button'
        css={btnStyles(viewMode === 'list')}
        onClick={() => onViewModeChange('list')}
        disabled={disabled}
        aria-label='List view'
      >
        <UnorderedListOutlined />
        List
      </button>
      <button
        type='button'
        css={btnStyles(viewMode === 'calendar')}
        onClick={() => onViewModeChange('calendar')}
        disabled={disabled}
        aria-label='Calendar view'
      >
        <CalendarOutlined />
        Calendar
      </button>
    </div>
  )
}

export default ViewModeToggle
